import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./UsersSection.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { TableLabels } from "./TableLabels";
import { TableBody } from "./TableBody/TableBody";
import { useState } from "react";
import { AddUserModal } from "../AddUserModal/AddUserModal";
import { useQuery } from "@tanstack/react-query";
import { getUsersList } from "../../model/services/getUsersList";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { reportErrorToSentry } from "@/frontend/shared/lib/reportErrorToSentry/reportErrorToSentry";

export function UsersSection() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["usersData"],
    queryFn: getUsersList,
    throwOnError: (error) => {
      console.error(error);

      reportErrorToSentry(error, "SETTINGS: /users");
      return true;
    }
  });
  const [isOpenAddUserModal, setIsOpenAddUserModal] = useState(false);

  const content = isLoading ? (
    <div className={styles.loadingContainer}>
      <Loader />
    </div>
  ) : (
    <TableBody data={data || []} triggerRefetch={refetch} />
  );

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <Typography variant="heading-6" color="greyscale800">
          Users
        </Typography>
        <NormalButton size="medium" leftIcon onClick={() => setIsOpenAddUserModal(true)}>
          Add User
        </NormalButton>
        <AddUserModal isOpen={isOpenAddUserModal} onClose={() => setIsOpenAddUserModal(false)} />
      </div>
      <div className={styles.contentContainer}>
        <TableLabels />
        {content}
      </div>
    </div>
  );
}
